import axios from 'axios';
import { getLatestToken } from 'services/auth';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PINNACLE_API_BASE_URL,
  withCredentials: false,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getLatestToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
